module.exports = __webpack_public_path__ + "img/sankaku_28_blue.84090300.png";